/* import __COLOCATED_TEMPLATE__ from './tag-usage-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();